/** @format */

import React, { useState } from 'react';
import { AnnotationIcon } from '@heroicons/react/solid';
import { blogs } from '../../data';
import { useNavigate } from 'react-router-dom';

export default function Blogs() {
  const [displayedBlogs, setDisplayedBlogs] = useState(2);
  const [showLess, setShowLess] = useState(false);
  const navigate = useNavigate();

  const showMoreBlogs = () => {
    setDisplayedBlogs(displayedBlogs + 2);
    setShowLess(true);
  };

  const showLessBlogs = () => {
    setDisplayedBlogs(2);
    setShowLess(false);
  };

  const maxDescriptionLength = 250;
  const truncateDescription = (description) => {
    if (description.length > maxDescriptionLength) {
      return description.slice(0, maxDescriptionLength) + '...';
    }
    return description;
  };

  const redirectToBlogPage = (blogId) => {
    navigate(`/blogs/${blogId}`); // Assuming your route to BlogPageView is '/blog/:blogId'
  };

  return (
    <section id="blogs">
      <div className="container px-5 py-10 mx-auto text-center">
        <AnnotationIcon className="inline-block w-10 mb-4" />
        <h1 className="mb-12 text-3xl font-medium text-white sm:text-4xl title-font">
          Blog
        </h1>
        <div className="flex flex-wrap m-4">
          {blogs.slice(0, displayedBlogs).map((blog) => (
            <div className="w-full p-4 transition-transform transform md:w-1/2 hover:scale-105">
              <div
                className="h-full p-8 bg-gray-800 rounded cursor-pointer bg-opacity-40"
                onClick={() => redirectToBlogPage(blog.id)}
              >
                <span className="block w-8 grid-cols-2 gap-2 mb-4 text-xs font-bold text-white rounded whitespace-nowrap text-white-500">
                  {blog.type}
                </span>
                <div className="relative flex w-full mb-6 bg-bg-gray">
                  <div className="items-start p-2 mb-5 mr-20 text-2xl font-semibold tracking-widest text-left title-font">
                    <span>{blog.title}</span>
                  </div>
                  <div>
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="absolute top-0 right-0 object-cover w-24 h-24 transform -translate-y-8 rounded sm:w-16 sm:h-16 "
                    />
                  </div>
                </div>
                <p className="mb-6 leading-relaxed text-justify">
                  {truncateDescription(blog.description)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {showLess ? (
          <button
            className="px-4 py-2 mt-4 font-bold text-white bg-red-500 rounded-full hover:bg-red-700"
            onClick={showLessBlogs}
          >
            Show Less
          </button>
        ) : (
          <button
            className="px-4 py-2 mt-4 font-bold text-white bg-blue-500 rounded-full hover:bg-blue-700"
            onClick={showMoreBlogs}
          >
            See More
          </button>
        )}
      </div>
    </section>
  );
}
